import { useId } from 'react';

export interface LogoMarkProps {
  /** Côté en pixels. */
  size?: number;
  className?: string;
}

/**
 * Logo Apovisio « Sommet » : un A en forme de sommet (l'apogée), le point figure l'objectif de la
 * caméra. Toujours accompagné du nom du produit, il est décoratif et masqué aux technologies
 * d'assistance. Ses couleurs sont celles de la marque, indépendantes du thème.
 */
export function LogoMark({ size = 32, className }: LogoMarkProps) {
  const gradientId = `av-logo-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0b5fa3" />
          <stop offset="1" stopColor="#033763" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#${gradientId})`} />
      <path
        d="M17 46 32 18l15 28"
        fill="none"
        stroke="#ffffff"
        strokeWidth="7.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="40" r="4.8" fill="#8cc0f0" />
    </svg>
  );
}
